<!-- компонент: выбор бэкапа при создании VDS -->
<template>
	<div>
		<div style="font-weight: 400; margin-bottom: 4px">{{ 'service/backup' | ftc }}:</div>
		<div v-if="list && list.length" class="wrapper">
			<div v-for="item in list"
				class="item"
				:key="item.id"
				:class="{
					'selected': String(item.id) === curValue,
					'disabled': !isEnabled(item)
				}"
				:title="generateTitle(item)"
				@mouseover="mouseOver(item)"
				@mouseleave="mouseLeave"
				@click="onItemClick(item)">
					<div v-if="item['image'] && item['image'].length" class="left-part">
						<img :src="APIServerUrl + item['image']" />
						<span v-if="item.datacenter_country" class="flag-icon" :class="'flag-icon-' + item.datacenter_country"
							:alt="item.datacenter_name || item.datacenter_country"
							:title="item.datacenter_name || item.datacenter_country"
							style="width: 12px; top: -3px">
						</span>
					</div>
					<div v-else class="left-part clmn">
						<font-awesome-icon icon="hdd" />
						<span v-if="item.datacenter_country" class="flag-icon" :class="'flag-icon-' + item.datacenter_country"
							:alt="item.datacenter_name || item.datacenter_country"
							:title="item.datacenter_name || item.datacenter_country"
							style="width: 12px">
						</span>
					</div>
					<div class="right-part">
						<span v-if="item['name']" class="name">#{{ item['id'] }} {{ item['name'] }}</span>
						<br v-if="item['size'] || item['created']" />
						<span v-if="item['size']" class="name">{{ 'service/iso_size' | ftc }}: {{ item['size'] }}</span><span v-if="item['created']" class="name">, </span>
						<span v-if="item['created']" class="name">{{ 'main/created' | ftc }}: {{ item['created'] | date('d.m.Y') }}</span>
					</div>
					<div v-show="showedTopHintId === item.id"
						class="top-hint">
						<span v-withSafeTags="makeReason(item)">
						</span>
					</div>

			</div>
		</div>
		<div v-else class="wrapper">
			<span class="empty-message">
				{{ 'service/backup_list_empty' | ftc }}
			</span>
			<div style="width: 100%">
				<a v-if="AppName === 'vdsina'" href="https://vdsina.ru/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
					{{ 'backup/hint_how_to_make' | ftc }}
				</a>
				<a v-if="AppName === 'vdsina.com'" href="https://vdsina.com/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
					{{ 'backup/hint_how_to_make' | ftc }}
				</a>
				<a v-else-if="AppName === 'macloud'" href="https://macloud.ru/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
					{{ 'backup/hint_how_to_make' | ftc }}
				</a>
			</div>
		</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'backupChoiceComponent',

	//=========================================================================
	// свойства переданные родителем
	//=========================================================================
	props: {
		value: {
			required: true
		},
		list: {
			type: Array,
			required: true
		},
		action: {
			required: true
		},
		readonly: {
			type: Boolean
		}
	},

	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			curValue: null,
			showedTopHintId: null
		}
	},

	//=========================================================================
	// обработчик события: компонент создан (все вычеслено)
	//=========================================================================
	created() {
		this.initValue()
	},

	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		initValue() {
			this.curValue = null

			let item = null
			if (this.value && typeof this.value === 'object' && 'id' in this.value)
				item = this.value
			else
			{
				let id = String(this.value)
				if (this.list && this.list.length)
				{
					this.list.some(i => {
						if (i && String(i.id) === id)
						{
							item = i
							return true
						}
					})
				}
			}

			if (item && this.isEnabled(item))
				this.curValue = String(item.id)

			// если список не пустой и есть указание
			// по выбору бэкапа
			if (this.list && this.list.length && window && window.sessionStorage)
			{
				let _crtFromBackup = window.sessionStorage.getItem('create-outer-disk-from-backup')
				if (_crtFromBackup)
				{
					// сразу обнулим хранилище
					window.sessionStorage.removeItem('create-outer-disk-from-backup')

					// конвертируем
					let _crtStore = null
					try {
						_crtStore = JSON.parse(_crtFromBackup)
					}
					catch (e)
					{
						_crtStore = null
					}

					// если бэкап задан
					if (_crtStore && _crtStore.service_id)
					{
						// проверим его наличие в списке
						this.list.some(b => {
							if (b && String(b.id) === String(_crtStore.service_id))
							{
								this.curValue = String(b.id)
								this.$emit('input', this.curValue)
								return true
							}
						})
					}
				}
			}
		},

		onItemClick(item) {
			this.$emit('focus')

			if (!item || !item.id || !this.isEnabled(item)) return

			// если хотят обнулить выбор
			if (this.curValue === String(item.id))
			{
				this.curValue = null
				this.$emit('input', null)
				return
			}

			this.curValue = String(item.id)
			this.$emit('input', item.id)
		},

		mouseOver(item) {
			if (!item || this.isEnabled(item)) return
			if (this.showedTopHintId === item.id) return
			this.showedTopHintId = item.id
		},

		mouseLeave() {
			this.showedTopHintId = null
		},

		makeReason(item) {
			if (!item) return

			if (!item.active)
				return this.localeFtc('service/not_active')

			if (!item.enable ||
				!item.plans || !item.plans.length)
				return this.localeFtc('backup/create_vds_error')

			return ''
		},

		isEnabled(Item) {
			let item = null
			if (Item && typeof Item === 'object' && 'id' in Item)
				item = Item
			else
			{
				let id = String(Item)
				this.list.some(i => {
					if (i && String(i.id) === id)
					{
						item = i
						return true
					}
				})
			}

			return item && item.id && item.enable && item.active
		},

		generateTitle(item) {
			let title = ''
			if (!item || typeof item !== 'object') return title

			if (item.id) title = '#' + item.id
			if (item.name) title += (title ? ' ' : '') + item.name
			if (item.size || item.created) title += '\n'
			if (item.size) title += this.localeFtc('service/iso_size') + ': ' + item.size + (item.created ? ', ' : '')
			if (item.created) title += this.localeFtc('main/created') + ': ' + this.formater_StrDateFormat(item.created, 'd.m.Y')

			return title
		}
	},

	//=========================================================================
	// наблюдаем за свойствами
	//=========================================================================
	watch: {
		value: {
			handler: function() {
				this.initValue()
			},
			immediate: true
		},
		list: {
			handler: function() {
				this.initValue()
			},
			immediate: true
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.wrapper {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
}
.item {
	position: relative;
	padding: 5px 0;
	margin: 0 10px 10px 0;

	display: inline-flex;
	display: -webkit-inline-box;
	display: -webkit-inline-flex;

	justify-content: flex-start;
	-webkit-justify-content: flex-start;

	align-items: center;
	-webkit-align-items: center;

	border: 1px solid #ddd;
    border-radius: 4px;

	transition: all .2s;
	cursor: pointer;

	color: black;

	width: 272px;
	height: 50px;
}
.item.selected, .item:hover {
	background-color: #dceeff;
    border-color: #3ba3ff;
}
.item.disabled, .item.disabled:hover {
	background-color: #eee;
    border-color: #ccc;
    color: #aaa;
}

.left-part.clmn {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	align-items: center;
	-webkit-align-items: center;

	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
}

.left-part {
	flex: 1 1 50px;
	text-align: center;
	line-height: 0;
}

.left-part img { width: 30px; height: auto }

.right-part {
	flex: 1 1 100%;
	font-size: 12px;
	font-weight: 400;
	padding-right: 10px;
	white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.top-hint {
    position: absolute;
    bottom: 55px;
    padding: 10px;
    border-radius: 4px;
    font-size: 13.5px;
    font-weight: 300;
    background: #fff5ee;
    border: 1px solid #f9caa7;
    color: #333;
}
.top-hint::before, .top-hint::after {
    content: '';
    position: absolute;
    left: 20px;
    bottom: -10px;
    border: 5px solid transparent;
    border-top: 5px solid #f9caa7;
}
.top-hint::after {
    border-top: 5px solid #fff5ee;
    bottom: -8px;
}

.copy-to-dc-btn {
	position: absolute;
	top: 4px;
	right: 4px;
	width: 12px;
	color: green;
	transition: color 0.2s;
	cursor: pointer;
}
.copy-to-dc-btn:hover {
	color: #33cc66
}
</style>



// WEBPACK FOOTER //
// backupList.vue?79a6d47a